module.exports = __webpack_public_path__ + "img/serviceState3.91381aca.svg";